'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.T = exports.E = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _types = require('./types');

var TYPES = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventService = function () {
    function EventService() {
        _classCallCheck(this, EventService);

        this.registry = {};
    }
    // 绑定事件


    _createClass(EventService, [{
        key: 'on',
        value: function on(key, callback) {
            if (typeof this.registry[key] === 'undefined') {
                this.registry[key] = [];
            }
            this.registry[key].push(callback);
        }

        // 解除事件绑定

    }, {
        key: 'off',
        value: function off(key, callback) {
            if (typeof this.registry[key] === 'undefined') {
                return;
            }
            var queue = this.registry[key];
            var i = queue.length;
            while (i--) {
                if (queue[i] === callback) {
                    queue.splice(i, 1);
                }
            }
        }

        //解除所有绑定

    }, {
        key: 'clearAllEvents',
        value: function clearAllEvents() {
            this.registry = {};
        }

        // 触发事件

    }, {
        key: 'emit',
        value: function emit(key, args) {
            if (typeof this.registry[key] === 'undefined') {
                return;
            }
            var queue = this.registry[key];
            for (var i = 0, l = queue.length; i < l; i++) {
                queue[i].call(null, args);
            }
        }
    }]);

    return EventService;
}();

var E = exports.E = new EventService();

var T = exports.T = {
    loading: function loading() {
        return E.emit(TYPES.SHOW_LOADING);
    },
    loaded: function loaded() {
        return E.emit(TYPES.HIDE_LOADING);
    },
    confirm: function confirm(args) {
        return E.emit(TYPES.SHOW_CONFIRM, args);
    },
    alert: function alert(args) {
        return E.emit(TYPES.SHOW_ALERT, args);
    },
    notify: function notify(args) {
        return E.emit(TYPES.SHOW_NOTICE, args);
    },
    clear: function clear() {
        return E.emit(TYPES.CLEAR);
    },
    ok: function ok(args) {
        return E.emit(TYPES.SHOW_OK, args);
    },
    fail: function fail(args) {
        return E.emit(TYPES.SHOW_FAIL, args);
    }
};